import icError from '@/assets/images/icons/error.svg';
import icMagnifyingGlass from '@/assets/images/icons/magnifying-glass.svg';
import { ErrorPageType } from '@/types';
import { bem } from '@/utilities';
import React, { useContext, useEffect } from 'react';
import { Inquiry } from '../inquiry';
import { InquiryContext } from '@/providers';

interface Props {
  type: ErrorPageType;
}

type ButtonType = 'reload';

interface ErrorParams {
  [key: string]: {
    icon: string;
    title: string;
    subDescription: JSX.Element | JSX.Element[];
    buttonType?: ButtonType;
  };
}

export const ErrorPage: React.FC<Props> = (props) => {
  const { setDisabled } = useContext(InquiryContext);

  const { type } = props;
  const params: ErrorParams = {
    NotFound: {
      icon: icMagnifyingGlass,
      title: '404 Not Found',
      subDescription: (
        <>
          お探しのページが見つかりませんでした。
          <br />
          URLをご確認お願いします。
        </>
      )
    },
    Expired: {
      icon: icError,
      title: '有効期限切れ',
      subDescription: (
        <>
          URLが期限切れです。
          <br />
          URLをご確認お願いします。
        </>
      )
    },
    Error: {
      icon: icError,
      title: 'error',
      subDescription: (
        <>
          エラーが発生しました。
          <br />
          お手数ですがページの更新をお願いします。
        </>
      ),
      buttonType: 'reload'
    }
  };

  useEffect(() => {
    setDisabled(type !== 'Expired');
  }, [setDisabled, type]);

  const handleReloadButton = () => {
    window.location.reload();
  };

  const buttonView = (buttonType?: ButtonType) => {
    if (!buttonType) return <></>;

    switch (buttonType) {
      case 'reload':
        return (
          <button className={bem('error-page', 'button')} onClick={() => handleReloadButton()}>
            更新する
          </button>
        );
      default:
        return <></>;
    }
  };

  return (
    <div className='error-page'>
      <div className={bem('error-page', 'container')}>
        <div className={bem('error-page', 'icon')}>
          <img src={params[type].icon} />
        </div>
        <div className={bem('error-page', 'title')}>{params[type].title}</div>
        <div className={bem('error-page', 'description')}>
          <div>{params[type].subDescription}</div>
        </div>
        {buttonView(params[type].buttonType)}
        <Inquiry />
      </div>
    </div>
  );
};
